import React from 'react';
import CustomTooltip from '../../Utils/CustomTooltip';

const PersonalInfo = ({ candidateProfile, roleCategory, formatDate }) => {
  return (
    <div className="bg-white rounded-lg shadow" style={{ overflow: 'visible', borderRadius: '0.5rem' }}>
      <div className="bg-blue-600 px-6 py-4 rounded-t-lg" style={{ overflow: 'visible' }}>
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-xl font-bold text-white flex items-center">
              <span>{candidateProfile.firstname || "N/A"} {candidateProfile.lastname || "N/A"}</span>
            </h3>
            <CustomTooltip 
              content={candidateProfile.role?.rationale || "No rationale provided"}
              className="text-lg"
            >
              <p className="text-blue-100 text-lg mt-1 cursor-help font-bold">
                {candidateProfile.role?.role || "No role assumed"}
              </p>
            </CustomTooltip>
            {candidateProfile.totalYearsOfExperience?.years && (
                <CustomTooltip 
                  content={candidateProfile.totalYearsOfExperience.rationale || "No rationale provided"}
                  className="text-lg"
                >
                  <span className="ml-2 text-lg text-blue-100 cursor-help">
                    ({candidateProfile.totalYearsOfExperience.years} years of experience)
                  </span>
                </CustomTooltip>
              )}
          </div>
          <div>
            {candidateProfile.seniority?.level && (
              <CustomTooltip 
                content={candidateProfile.seniority.rationale || "No rationale provided"}
                className="text-lg"
                position="left"
              >
                <span className="inline-block bg-blue-700 text-white px-3 py-1 rounded-full text-sm font-medium cursor-help">
                  {candidateProfile.seniority.level}
                </span>
              </CustomTooltip>
            )}
          </div>
        </div>
      </div>
      
      {/* Role Category Section - Dimmer blue background bar */}
      {roleCategory && (
        <div className="bg-blue-400 px-6 py-3">
          <div className="flex flex-wrap items-center gap-6 text-white">
            <div>
              <span className="font-bold">Role Category:</span> {roleCategory.mainCategory || "N/A"}
            </div>
            <div>
              <span className="font-bold">Role:</span> {roleCategory.subCategory || "N/A"}
            </div>
            {roleCategory.altSubcategory && (
              <div>
                <span className="font-bold">Alt Role:</span> {roleCategory.altSubcategory}
              </div>
            )}
          </div>
        </div>
      )}
      
      <div className="px-6 py-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <h4 className="text-sm font-medium text-gray-500">Contact Information</h4>
            <div className="mt-2 space-y-1">
              <p className="text-gray-700">
                <span className="font-medium">Email:</span> {
                  candidateProfile.contact?.emails ? 
                    candidateProfile.contact.emails.join(', ') : 
                    candidateProfile.contact?.email || "No data"
                }
              </p>
              <p className="text-gray-700">
                <span className="font-medium">Mobile:</span> {
                  candidateProfile.contact?.mobiles ? 
                    candidateProfile.contact.mobiles.join(', ') : 
                    candidateProfile.contact?.mobile || "No data"
                }
              </p>
              <p className="text-gray-700">
                <span className="font-medium">Address:</span> {
                  candidateProfile.contact?.addresses ? 
                    candidateProfile.contact.addresses.join(', ') : 
                    candidateProfile.contact?.address || "No data"
                }
              </p>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500">Personal Details</h4>
            <div className="mt-2 space-y-1">
              <p className="text-gray-700">
                <span className="font-medium">Date of Birth:</span> {candidateProfile.birthdate ? formatDate(candidateProfile.birthdate) : "No data"}
              </p>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500">Links</h4>
            <div className="mt-2">
              {candidateProfile.contact?.links && candidateProfile.contact.links.length > 0 ? (
                <ul className="list-disc list-inside text-gray-600 text-sm pl-2">
                  {candidateProfile.contact.links.map((link, idx) => {
                    // Handle both string links and object links for backward compatibility
                    const linkUrl = typeof link === 'string' ? link : link.url || link;
                    const linkText = typeof link === 'string' ? link : link.text || linkUrl;
                    
                    return (
                      <li key={idx}>
                        <a 
                          href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline"
                        >
                          {linkText}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p className="text-gray-700">No links available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
